// extracted by mini-css-extract-plugin
export default {"checkCircleIcon":"ApprovedQuote_checkCircleIcon__vsQIX","button":"ApprovedQuote_button__Llxy+","cardMessage":"ApprovedQuote_cardMessage__n4nq6","p":"ApprovedQuote_p__c4XI+"};